'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    INITIAL_STATE_INGRESO_AJUSTES,
    GET_DATA_INGRESO_AJUSTES,
    RECEIVE_DATA_INGRESO_AJUSTES,
    CHANGE_DATA_INGRESO_AJUSTES,
    EXPANDIR_ROW_INGRESO_AJUSTES,
    SUCCESS_INGRESO_AJUSTES,
    LIMPIAR_INGRESO_AJUSTES,
    ELIMINAR_INGRESO_AJUSTES,
    EDITAR_INGRESO_AJUSTES,
    CONFIRMAR_INGRESO_AJUSTES,
    DENEGAR_INGRESO_AJUSTES,
    SELECT_MOTIVO_AJUSTE_COMBO,
    CHANGE_IMPORTE_SIN_IVA
} from '../../Screens/IngresoAjustes/actions/IngresoAjustesActions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        cuenta: undefined,
        ajustes: [],
        tipoMoneda: [],
        fechaValor: new Date(),
        monedaId: 0,
        cuentaTarjetaId: undefined,
        ajusteMotivo: [],
        tarjetaVigencia: [],
        rowSeleccionada: undefined,
        sucursalId: 0,
        ajusteEstadoId: 0,
        ajusteOrigenId: 0,
        tarjetaCreditoId: 0,
        debitoCredito: undefined,
        impactaPeriodo: undefined,
        permiteIva: 0,
        tasaIva: 1,
        motivoAjusteId: 0,
        importeConIva: 0,
        isLoading: false
    }
};

function ingresoAjustes(state = initialState, action) {
    LogHelper.In(ingresoAjustes.name, state, action);

    switch (action.type) {

        case INITIAL_STATE_INGRESO_AJUSTES:
            return initialState;

        case GET_DATA_INGRESO_AJUSTES:
            return initialState

        case RECEIVE_DATA_INGRESO_AJUSTES: {
            if (action.motivoId == 0) {
                return {
                    ...initialState,
                    data: {
                        ...initialState.data,
                        ajustes: action.data.ajustes,
                        tipoMoneda: action.data.tipoMoneda,
                        fechaCobranza: action.data.fechaCobranza,
                        ajusteMotivo: action.data.ajusteMotivo,
                        cuentaTarjetaId: action.data.cuentaTarjetaId,
                        sucursalId: action.data.sucursalId,
                        ajusteEstadoId: action.data.cobranzaEstadoId,
                        ajusteOrigenId: action.data.cobranzaOrigenId,
                        tarjetaCreditoId: action.data.tarjetaCreditoId,
                        tarjetaVigencia: action.data.tarjetaVigencia,
                        isLoading: false
                    }
                }

            }

            return {
                ...state,
                data: {
                    ...state.data,
                    ajustes: action.data.ajustes,
                    tipoMoneda: action.data.tipoMoneda,
                    fechaCobranza: action.data.fechaCobranza,
                    ajusteMotivo: action.data.ajusteMotivo,
                    cuentaTarjetaId: action.data.cuentaTarjetaId,
                    sucursalId: action.data.sucursalId,
                    ajusteEstadoId: action.data.cobranzaEstadoId,
                    ajusteOrigenId: action.data.cobranzaOrigenId,
                    tarjetaCreditoId: action.data.tarjetaCreditoId,
                    tarjetaVigencia: action.data.tarjetaVigencia,
                    isLoading: false
                }
            };
        }
        case CHANGE_DATA_INGRESO_AJUSTES:

            return {
                ...state,
                data: {
                    ...state.data,
                    debitoCredito: action.data.debitoCredito,
                    tipoMoneda: action.data.tipoMoneda,
                    monedaId: (action.data.tipoMoneda[0].Id || 0),
                    impactaPeriodo: action.data.impactaPeriodo,
                    permiteIva: action.data.permiteIva,
                    tasaIva: action.data.tasaIva,
                    cuentaTarjetaId: action.data.cuentaTarjetaId

                }
            };

        case SELECT_MOTIVO_AJUSTE_COMBO:
            return {
                ...state,
                data: {
                    ...state.data,
                    motivoAjusteId: action.id
                }
            }

        case CHANGE_IMPORTE_SIN_IVA:
            return {
                ...state,
                data: {
                    ...state.data,
                    importeConIva: action.numero
                }
            }

        case EXPANDIR_ROW_INGRESO_AJUSTES:
            let id = undefined;
            if (state.data.rowSeleccionada != action.id) {
                if (state.data.rowSeleccionada == action.id) {
                    id = undefined
                }
                else {
                    id = action.id
                }
            }

            return {
                ...state,
                data: {
                    ...state.data,
                    rowSeleccionada: id
                }
            };

        case SUCCESS_INGRESO_AJUSTES:
            return {
                ...state,
                isLoading: false
            };

        case LIMPIAR_INGRESO_AJUSTES:
            return {
                ...state,
                data: {
                    ...state.data,
                    accion: "guardar"
                }
            };

        case ELIMINAR_INGRESO_AJUSTES:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }

        case EDITAR_INGRESO_AJUSTES:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }

        case CONFIRMAR_INGRESO_AJUSTES:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }

        case DENEGAR_INGRESO_AJUSTES:
            return {
                ...state,
                data: {
                    ...state.data,
                }
            }
            return {
                ...state,
                data: {
                    ...state.data,
                    rowSeleccionada: id
                }
            };
        default:
            return state;
    }
}

export default ingresoAjustes;


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Store/Reducers/IngresoAjustes.js